export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return

  const registerSW = () => {
    if ('serviceWorker' in navigator && location.protocol === 'https:') {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log('SW registered:', registration)
        })
        .catch((error) => {
          console.log('SW registration failed:', error)
        })
    }
  }

  // Defer registration until browser is idle
  if ('requestIdleCallback' in window) {
    requestIdleCallback(registerSW)
  } else {
    // Fallback for browsers without requestIdleCallback
    window.addEventListener('load', () => {
      setTimeout(registerSW, 1000)
    })
  }
})
